import React from 'react'
import R from 'ramda'
import {connect} from 'react-redux'
import ReactDOM from 'react-dom'

import FlipCard from './FlipCard'
import EstateSmallCard from './EstateSmallCard'
import EstateBigCard from './EstateBigCard'
import EstateSelectedCard from './EstateSelectedCard'

import flipEstateCard from '../actions/flipEstateCard'

import {poiToString} from '../utils/queryObjectMapper'

import {estateDetailsPage} from 'conf'
import getCurrentQuery from '../utils/getCurrentQuery'
import updateViewPort from '../actions/updateViewPort'

class EstateFlipableCard extends React.Component {
  shouldComponentUpdate(nextProps){
    return !R.equals(nextProps, this.props)
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.selected && !this.props.selected){
      setTimeout( _ => {
        const elm = ReactDOM.findDOMNode(this._elm)
        {/*elm.scrollIntoViewIfNeeded()*/}

        this.smoothScroll(elm);                
      }, 100)
    }
  }
  render(){
    const {map, estate, options, selected, onFlip, proximityScore, more, zoom, viewPort} = this.props
    //const partner = R.prop('name', R.find(R.propEq('id', estate.partner), options.partners))
    const partner = estate.pfname
    const query = getCurrentQuery()
    const pois = R.map(poiToString, query.pois).join('/')
    const detailsUrl = estateDetailsPage(estate.id, pois)
    
    const estateProps = {...estate, partner, detailsUrl}

    return <FlipCard ref={elm => this._elm = elm}
                     style={{minHeight: "110px"}} 
                     key={`${estate.id}-card`} 
                     flipped={selected}
                     onFlip={onFlip(estate,estate.id,zoom,viewPort,map)}
                     more={more}>
             <EstateSmallCard key={`${estate.id}-front`} {...estateProps} proximityScore={proximityScore}/>
             <EstateSelectedCard key={`${estate.id}-front`} {...estateProps} proximityScore={proximityScore}/>
             <EstateBigCard key={`${estate.id}-back`}  {...estateProps} proximityScore={proximityScore}/>
           </FlipCard>
  }

  smoothScroll(elm){
    var searchFormElement = document.getElementById("searchForm");
    {/*searchFormElement.scrollTop = searchFormElement.scrollTop + (elm.getBoundingClientRect().bottom - elm.getBoundingClientRect().top)/2 + elm.getBoundingClientRect().top - searchFormElement.offsetHeight/2*/}

    {/*
    var step = ((elm.getBoundingClientRect().bottom - elm.getBoundingClientRect().top)/2 + elm.getBoundingClientRect().top - searchFormElement.offsetHeight/2)/200
    for(var i=0;i<200;i++)
    {
      searchFormElement.scrollTop += step
    }*/}

    var startPos = searchFormElement.scrollTop;
    {/*var initialDistance = (elm.getBoundingClientRect().bottom - elm.getBoundingClientRect().top)/2 + elm.getBoundingClientRect().top - searchFormElement.offsetHeight/2*/}

    var initialDistance = elm.offsetTop - searchFormElement.scrollTop - searchFormElement.offsetHeight/3;

    var x = 0;
    var startTime = Date.now();

    return new Promise(function(resolve,reject){

        var previousTop = searchFormElement.scrollTop;

        var scroll = function(){

          if(searchFormElement.scrollTop != previousTop) {
                reject("interrupted");
                return;
            }


          {/*var distance = (elm.getBoundingClientRect().bottom - elm.getBoundingClientRect().top)/2 + elm.getBoundingClientRect().top - searchFormElement.offsetHeight/2*/}
          var distance = elm.offsetTop - searchFormElement.scrollTop - searchFormElement.offsetHeight/3;

          x = Math.round(1+Math.abs(distance/(searchFormElement.offsetHeight/2))*6);
          
          if(distance > 0)
          {
            searchFormElement.scrollTop += x
          }
          else
          {
            searchFormElement.scrollTop -= x
          }

          if(Math.abs(distance)<10) {
              resolve();
              return;
          }

          previousTop = searchFormElement .scrollTop;
          setTimeout(scroll, 0);
        }
        setTimeout(scroll, 0);        
    })  

  }

}

EstateFlipableCard.propTypes = {
  estate: React.PropTypes.object.isRequired,
  options: React.PropTypes.object.isRequired,
  selected: React.PropTypes.bool.isRequired,
  onFlip: React.PropTypes.func.isRequired,
  proximityScore: React.PropTypes.number.isRequired,
}

const mapStateToProps = (state, ownProps) => ({
  options: state.options,
  estate: R.path(['estates', ownProps.id, 'data'], state),
  selected: state.selectedEstateId == ownProps.id,
  more: state.more,
  zoom: state.zoom,
  viewPort: state.viewPort,
  map: state.map
})

const mapDispatchToProps = (dispatch) => ({
  onFlip: (estate,estateId,zoom,viewPort,map) => _ => {
    if(zoom<14)
    {
      map.setZoomAround(estate.coordinates,14);
    }
    else if(estate.coordinates.lat>viewPort.topLeft.lat ||
            estate.coordinates.lat<viewPort.bottomRight.lat ||
            estate.coordinates.lng<viewPort.topLeft.lng ||
            estate.coordinates.lng>viewPort.bottomRight.lng)
    {
      map.panTo(estate.coordinates);
    }

    dispatch(flipEstateCard(estateId));
  } 
})
  
export default connect(mapStateToProps, mapDispatchToProps)(EstateFlipableCard)



/** WEBPACK FOOTER **
 ** ./app/components/EstateFlippableCard.jsx
 **/